export const locale = {
    lang: 'ds',
    data: {
        'FIELDS': {
            'SelectProject': 'Vælg Projekt',
        },
    }
};

